import faqContentDe from '../faq-de';
import faqContentEn from '../faq-en';
import faqContentEs from '../faq-es';
import faqContentPl from '../faq-pl';
import { getLang } from '../lang';

export const getFaqContent = () => {
  const langCode = getLang();

  if (langCode === 'es') {
    return faqContentEs;
  }
  if (langCode === 'pl') {
    return faqContentPl;
  }
  if (langCode === 'en') {
    return faqContentEn;
  }

  return faqContentDe;
};
